/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA`)
};

const es_dnamw_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARNss`)
};

const de_dnamw_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA`)
};

const nl_dnamw_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA`)
};

const fr_dnamw_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARNsb`)
};

const it_dnamw_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA`)
};

const pt_br2_dnamw_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA`)
};

const pt_dnamw_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssARN`)
};

const ja_dnamw_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA`)
};

const zh_dnamw_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA（单链 RNA）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_ssrna = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_ssrna(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_ssrna", locale)
	if (locale === "en") return en_dnamw_ssrna(inputs)
	if (locale === "es") return es_dnamw_ssrna(inputs)
	if (locale === "de") return de_dnamw_ssrna(inputs)
	if (locale === "nl") return nl_dnamw_ssrna(inputs)
	if (locale === "fr") return fr_dnamw_ssrna(inputs)
	if (locale === "it") return it_dnamw_ssrna(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_ssrna(inputs)
	if (locale === "pt") return pt_dnamw_ssrna(inputs)
	if (locale === "ja") return ja_dnamw_ssrna(inputs)
	return zh_dnamw_ssrna(inputs)
};